// @flow
import { iddZoneSelector } from '../International/IDD';
import { travelZoneSelector } from '../International/Travel';
import config from '../../config';

export const selectedTopUpsSelector = (state: Object): { [string]: Object } => state.topUps.selected;

export const selectedTopUpsPriceSelector = (state: Object): number => {
  const selectedTopUps = selectedTopUpsSelector(state);

  return (Object.values(selectedTopUps): any).reduce(
    (price, currentTopUp) => price + currentTopUp.price.taxIncludedAmount,
    0
  );
};

export const availableTopUpsSelector = (state: Object, type: 'BOOSTER' | 'IDD' | 'ROAMING'): Object =>
  state.topUps.availableByType[type] || {};

export const availableTopUpsSelectorForType = (
  state: Object,
  type: 'BOOSTER' | 'IDD' | 'ROAMING'
): { [string]: Object[] } => {
  const availableTopUps = availableTopUpsSelector(state, type);

  if (type === config.international.BOOSTER) {
    return availableTopUps;
  }

  let selectedZone, AVAILABLE_TOP_UP_REGEX;
  if (type === config.international.IDD) {
    selectedZone = iddZoneSelector(state) || '';
    AVAILABLE_TOP_UP_REGEX = new RegExp(`.*(ZONE${selectedZone}).*`);
  } else if (type === config.international.ROAMING) {
    selectedZone = travelZoneSelector(state) || '';
    AVAILABLE_TOP_UP_REGEX = new RegExp(`.*(ROA${selectedZone}).*`);
  }

  return Object.keys(availableTopUps)
    .filter(key => AVAILABLE_TOP_UP_REGEX.test(key))
    .reduce((availableTopUpInSelectedZoneAcc, name) => {
      availableTopUpInSelectedZoneAcc[name] = availableTopUps[name];
      return availableTopUpInSelectedZoneAcc;
    }, {});
};

export const permanentTopUpSelector = (state: Object): Object[] => state.topUps.permanent;
